const ZDWST_STATE_VERSION_TYPE = 'ZDWST_STATE_VERSION_TYPE';
export default ZDWST_STATE_VERSION_TYPE ;
